export default __webpack_public_path__ + "static/media/6.daae5111.jpg";